export default {
  confirmation: 'CONFIRMATION',
  error: 'ERROR',
  information: 'INFORMATION',
  success: 'SUCCESS',
  warning: 'WARNING',
};
